export const CONTEXT_ID = 'contextId';

export const JS_ERROR_CODE = 600;

export const DISABLE_TRACKING = 'mt-ui-core/DISABLE_TRACKING';

export const EMPTY_OBJECT_READONLY = Object.freeze({});
